import { heroLead, speedNews, editorPicks } from "@/mocks/homeData";
import { TagPill } from "./kit";

export default function Cover() {
  return (
    <section id="cover" className="mx-auto max-w-6xl px-4 py-7 md:px-6 md:py-10">
      <div className="mb-5 flex items-end justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="h-6 w-1.5 rounded-full bg-accent-500" />
          <div>
            <p className="font-label text-[11px] font-medium tracking-[0.28em] text-foreground-400">
              今日封面 · COVER
            </p>
            <h2 className="mt-0.5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              本周头条深挖
            </h2>
          </div>
        </div>
        <span className="hidden whitespace-nowrap text-xs text-foreground-400 md:inline-flex">
          编辑部每周甄选一件大事拆到底
        </span>
      </div>

      <div className="grid gap-6 lg:grid-cols-3">
        {/* lead card */}
        <article className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:col-span-2">
          <div className="relative aspect-[16/9] w-full overflow-hidden md:aspect-[2/1]">
            <img
              src={heroLead.img}
              alt={heroLead.title}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/25 to-transparent" />
            <div className="absolute left-4 top-4 md:left-6 md:top-6">
              <TagPill tone="accent">{heroLead.tag}</TagPill>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 text-background-50 md:p-6">
              <p className="mb-2 flex flex-wrap items-center gap-2 text-xs text-background-50/70">
                <i className="ri-fire-line text-accent-400" />
                <span>阅读预计 {heroLead.count}</span>
              </p>
              <h3 className="max-w-3xl font-heading text-xl font-bold leading-snug md:text-[1.9rem] md:leading-tight">
                {heroLead.title}
              </h3>
              <p className="mt-2 hidden max-w-3xl text-sm leading-relaxed text-background-50/80 md:block">
                {heroLead.lede}
              </p>
            </div>
          </div>
          <div className="flex flex-wrap items-center justify-between gap-3 border-t border-background-200 px-5 py-3.5 md:px-6">
            <span className="text-xs text-foreground-500">
              <i className="mr-1.5 ri-edit-2-line text-accent-600" />
              {heroLead.author}
            </span>
            <button
              type="button"
              className="inline-flex cursor-pointer items-center gap-1.5 rounded-full bg-foreground-950 px-4 py-2 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-foreground-800"
            >
              进入完整时间线
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </article>

        {/* speed news column */}
        <div className="flex flex-col">
          <div className="mb-3 flex items-center justify-between">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-flashlight-line text-accent-600" />
              内幕速报
            </h3>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900">
              <span className="h-1.5 w-1.5 rounded-full bg-secondary-500" />
              随时刷更
            </span>
          </div>

          <div className="flex flex-1 flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-100">
            {speedNews.map((n) => (
              <button
                key={n.id}
                type="button"
                className="group flex cursor-pointer flex-col gap-1 px-4 py-3 text-left transition-colors hover:bg-background-50"
              >
                <span className="flex items-center gap-2">
                  <span className="font-label text-[11px] text-accent-600">{n.time}</span>
                  <span className="h-px flex-1 bg-background-200" />
                  <span className="inline-flex items-center gap-1 text-[11px] text-foreground-400">
                    <i className="ri-eye-line" />
                    {n.views}
                  </span>
                </span>
                <p className="line-clamp-2 text-sm font-medium leading-relaxed text-foreground-900 transition-colors group-hover:text-accent-800">
                  {n.title}
                </p>
              </button>
            ))}
          </div>

          <div className="mt-4 rounded-lg border border-secondary-200 bg-secondary-50 px-4 py-3">
            <p className="mb-2 flex items-center gap-1.5 font-label text-[11px] font-bold tracking-[0.18em] text-secondary-800">
              <i className="ri-bookmark-3-line" />
              编辑部工作笔记
            </p>
            <ul className="space-y-1.5">
              {editorPicks.map((t) => (
                <li key={t} className="flex items-start gap-2 text-[13px] leading-snug text-foreground-700">
                  <span className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-secondary-500" />
                  {t}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}